import { Fa6Searchengin } from "@onemind-services-llc/react-icons-ng/fa6";
import { GiFirewall } from "@onemind-services-llc/react-icons-ng/gi";
import { LuBug } from "@onemind-services-llc/react-icons-ng/lu";
import { BsCloudCheck } from "@onemind-services-llc/react-icons-ng/bs";
import { GoVerified } from "@onemind-services-llc/react-icons-ng/go";
import { RiSkull2Line } from "@onemind-services-llc/react-icons-ng/ri";
import { SiTestcafe } from "@onemind-services-llc/react-icons-ng/si";

import { ContentCard } from "@/components/contentCard";
import { SECURITY_SERVICES_ROUTES, MAIN_ROUTES } from "@/constants/routes";

export const CYBER_SECURITY_OPTIONS = [
  {
    icon: Fa6Searchengin,
    title: "EDR | MDR | XDR",
    subTitle: "The Future of Cybersecurity",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.EDR_MDR_XDR}`}
        points={[
          "Detect and stop advanced threats in real time.",
          "Automate response across endpoints and networks.",
          "Gain unified visibility and control from a single console.",
        ]}
      />
    ),
  },
  {
    icon: LuBug,
    title: "Ransomware & DDoS Protection",
    subTitle: "Stop Cyber Attacks Before They Start",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.RANSOMWARE_DDOS_PROTECTION}`}
        points={[
          "Stops ransomware & zero-day attacks.",
          "Continuous threat response & protection.",
          "Keeps networks and applications running 24/7.",
        ]}
      />
    ),
  },
  {
    icon: GiFirewall,
    title: "ZTNA | VPN | Edge Firewall | SASE",
    subTitle: "Secure Network Access",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.ZTNA_VPN_EDGE_FIREWALL_SASE}`}
        points={[
          "Restricts users to specific applications, not entire networks.",
          "Detects and blocks malware, phishing, and ransomware.",
          "Integrates security with SD-WAN for optimized performance.",
        ]}
      />
    ),
  },
  {
    icon: RiSkull2Line,
    title: "Vulnerability and Patch Management",
    subTitle: "Eliminate Security Gaps",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.VULNERABILITY_PATCH_MANAGEMENT}`}
        points={[
          "Identifies and prioritizes vulnerabilities in real time.",
          "Deploys security updates seamlessly without downtime.",
          "Stops exploits before they can be weaponized.",
        ]}
      />
    ),
  },
  {
    icon: GoVerified,
    title: "Compliance Management | SEC OPS",
    subTitle: "Ensure Regulatory Compliance",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.COMPLIANCE_MANAGEMENT}`}
        points={[
          "Streamlines audits and ensures regulatory adherence.",
          "Proactive Violation Detection",
          "Automated Incident Response",
        ]}
      />
    ),
  },
  {
    icon: BsCloudCheck,
    title: "Cloud security Posture Management",
    subTitle: "Unified Security & Network Optimization",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.CLOUD_SECURITY}`}
        points={[
          "Instant Cloud Protection – Stop threats before they spread.",
          "AI-Driven Security – Automate compliance and eliminate risks.",
          "Seamless Performance – Secure and optimize with SASE.",
        ]}
      />
    ),
  },
  {
    icon: SiTestcafe,
    title: "Security Assessment & Testing",
    subTitle: "Proactive Threat Detection",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.CLOUD_SECURITY}`}
        points={[
          "Identify vulnerabilities across networks, applications, and cloud environments.",
          "Perform penetration testing, configuration audits, and compliance gap analysis.",
          "Receive actionable remediation plans and risk scoring aligned with industry standards.",
        ]}
      />
    ),
  },
];
